var _MfsTelemetryBuffer_queue;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { MAX_BUFFER_SIZE } from '../telemetryTypes';
/**
 * Buffer class for logging things even before the telemetry system gets ready.A telemetry instance can buffer the
 * events sent by logger to store and flush them all out when they are ready.
 */
export class MfsTelemetryBuffer {
    constructor(bufferName) {
        _MfsTelemetryBuffer_queue.set(this, void 0);
        /** @inheritdoc */
        this.add = (callback) => {
            if (__classPrivateFieldGet(this, _MfsTelemetryBuffer_queue, "f").length >= MAX_BUFFER_SIZE) {
                if (!this.hasOverflowed) {
                    this.hasOverflowed = true;
                }
                __classPrivateFieldGet(this, _MfsTelemetryBuffer_queue, "f").shift();
            }
            __classPrivateFieldGet(this, _MfsTelemetryBuffer_queue, "f").push(callback);
        };
        /** @inheritdoc */
        this.flush = () => {
            __classPrivateFieldGet(this, _MfsTelemetryBuffer_queue, "f").forEach((callback) => callback());
            __classPrivateFieldSet(this, _MfsTelemetryBuffer_queue, [], "f");
            this.hasOverflowed = false;
        };
        /** @inheritdoc */
        this.empty = () => {
            __classPrivateFieldSet(this, _MfsTelemetryBuffer_queue, [], "f");
            this.hasOverflowed = false;
        };
        __classPrivateFieldSet(this, _MfsTelemetryBuffer_queue, [], "f");
        this.hasOverflowed = false;
        this.bufferName = bufferName;
    }
}
_MfsTelemetryBuffer_queue = new WeakMap();
//# sourceMappingURL=mfsTelemetryBuffer.js.map